import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import MKBox from "components/MKBox";
import ServiceGuidance from "components/ServiceGuidance";
import RotatingCard from "examples/Cards/RotatingCard";
import RotatingCardFront from "examples/Cards/RotatingCard/RotatingCardFront";
import RotatingCardBack from "examples/Cards/RotatingCard/RotatingCardBack";

import bgFront2 from "assets/images/poze-site/7-1-generala.webp";
import bgBack2 from "assets/images/poze-site/7-2-generala.webp";

const advantages = {
    items: [
        {
            title: "Eficiență și standarde ridicate",
            text: "Colaborarea cu noi înseamnă eficiență, rapiditate și respectarea celor mai înalte standarde de curățenie. Utilizăm echipamente moderne și produse sigure, astfel încât fiecare client se bucură de un spațiu curat, confortabil și întreținut conform normelor actuale de igienă.",
        },
        {
            title: "Parteneriate durabile și încredere",
            text: "Punem accent pe relații de lungă durată, bazate pe profesionalism, transparență și rezultate constante. Oferim servicii adaptate nevoilor fiecărui client, comunicare deschisă și garanția unui mediu mereu curat și bine întreținut.",
        },
        {
            title: "Servicii personalizate și rezultate vizibile",
            text: "Clienții noștri beneficiază de intervenții prompte, calitate constantă și soluții personalizate pentru fiecare tip de spațiu. Asigurăm seriozitate, transparență și rezultate vizibile, garantând siguranța unui mediu impecabil și igienizat profesional.",
        },
    ],
};

const advice = {
    paragraphs: [
        "Apelați exclusiv la firme de curățenie profesioniste, care pot garanta calitatea serviciilor și pot oferi asigurarea bunurilor printr-o poliță de protecție, în cazul unor eventuale daune.",
        "Solicitați informații despre produsele de curățenie utilizate, pentru a vă asigura că acestea nu sunt toxice, atât pentru membrii familiei sau colegii de lucru, cât și pentru mediul înconjurător.",
        "Asigurați-vă că echipamentele și metodele folosite sunt adecvate și sigure, pentru a preveni deteriorarea suprafețelor sensibile.",
    ],
};

function InformationHome() {
    return (
        <MKBox component="section" py={6} my={6}>
            <Container>
                <Grid container spacing={4} alignItems="stretch">
                    <Grid item xs={12} lg={4}>
                        <RotatingCard>
                            <RotatingCardFront image={bgFront2} icon="touch_app" title="Curățenie Generală" description="Curățare completă, până la cele mai fine detalii." />
                            <RotatingCardBack image={bgBack2} title="Garanția calității" description="Solicită o evaluare gratuită." action={{ type: "internal", route: "/contact-curatenie", label: "cere o ofertă" }} />
                        </RotatingCard>
                    </Grid>
                    <Grid item xs={12} lg={8}>
                        <ServiceGuidance advantages={advantages} advice={advice} />
                    </Grid>
                </Grid>
            </Container>
        </MKBox>
    );
}

export default InformationHome;
